import { WttpConfiguration } from './configuration';
import { WttpSurveys } from './wttp-surveys';
import { Issues } from './issues';
import Grid from '@mui/material/Grid';
import { ContentWrapper } from 'src/components/common/wrapper/content/wrapper';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';
import { Can } from 'src/utils/can';

export const Wttp = () => {
  return (
    <>
      <ContentWrapper>
        <WttpConfiguration />

        <Grid container spacing={2} className="mt-4">
          <Can
            I={Actions.Read}
            a={Subjects.QuestionnaireResponses}
            appArea={AppArea.Wttp}
          >
            <Grid item xs={12} sm={6}>
              <WttpSurveys />
            </Grid>
          </Can>
          <Can I={Actions.Read} a={Subjects.Issues} appArea={AppArea.Common}>
            <Grid item xs={12} sm={6}>
              <Issues />
            </Grid>
          </Can>
        </Grid>
      </ContentWrapper>
    </>
  );
};
